import AdminIndex from './pages/AdminIndex';
import AdminCategoryCreate from './pages/AdminCategoryCreate';
import AdminTagEdit from './pages/AdminTagEdit';
import AdminVideoCreate from './pages/AdminVideoCreate';
import AdminVideoIndex from './pages/AdminVideoIndex';
import AdminVideoTagSettings from './pages/AdminVideoTagSettings';
import Catalog from './pages/Catalog';
import Commerce from './pages/Commerce';
import Help from './pages/Help';
import Home from './pages/Home';
import Landing from './pages/Landing';
import MyPage from './pages/MyPage';
import Privacy from './pages/Privacy';
import Series from './pages/Series';
import Terms from './pages/Terms';
import VideoPlayer from './pages/VideoPlayer';
import Login from './pages/Login';
import OAuthCallback from './pages/OAuthCallback';
import RegistrationRequired from './pages/RegistrationRequired';
import MediaFormatLab from './pages/MediaFormatLab';
import WatchHistory from './pages/WatchHistory';
import __Layout from './Layout.jsx';


export const PAGES = {
    "AdminIndex": AdminIndex,
    "AdminVideoIndex": AdminVideoIndex,
    "AdminVideoCreate": AdminVideoCreate,
    "AdminVideoTagSettings": AdminVideoTagSettings,
    "AdminTagEdit": AdminTagEdit,
    "AdminCategoryCreate": AdminCategoryCreate,
    "Catalog": Catalog,
    "Commerce": Commerce,
    "Help": Help,
    "Home": Home,
    "Landing": Landing,
    "MyPage": MyPage,
    "Privacy": Privacy,
    "Series": Series,
    "Terms": Terms,
    "VideoPlayer": VideoPlayer,
    "Login": Login,
    "OAuthCallback": OAuthCallback,
    "RegistrationRequired": RegistrationRequired,
    "WatchHistory": WatchHistory,
    ...(import.meta.env.DEV ? { MediaFormatLab } : {}),
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};